import { brand, channelGroups, channels, faqs } from "@/mocks/homeData";

export default function StructuredData() {
  const graph = [
    {
      "@type": "Organization",
      "@id": "https://menghuanlater.cn/#organization",
      name: brand.name,
      description: brand.intro,
      email: brand.email,
      url: "https://menghuanlater.cn/",
    },
    {
      "@type": "WebSite",
      "@id": "https://menghuanlater.cn/#website",
      name: brand.name,
      alternateName: brand.slogan,
      url: "https://menghuanlater.cn/",
      inLanguage: "zh-CN",
      publisher: { "@id": "https://menghuanlater.cn/#organization" },
      potentialAction: {
        "@type": "SearchAction",
        target: "https://menghuanlater.cn/?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "WebPage",
      "@id": "https://menghuanlater.cn/#webpage",
      url: "https://menghuanlater.cn/",
      name: "黑料首页 | 栏目导航与站点地图",
      description:
        "黑料社娱乐热点频道导航门户，清晰列出娱乐、影视、综艺、网络热梗等板块与频道分区，并提供站点地图快速定位栏目入口。",
      isPartOf: { "@id": "https://menghuanlater.cn/#website" },
      inLanguage: "zh-CN",
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "首页",
          item: "https://menghuanlater.cn/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "频道导览",
          item: "https://menghuanlater.cn/#channels",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "站点地图",
          item: "https://menghuanlater.cn/#sitemap",
        },
      ],
    },
    {
      "@type": "ItemList",
      name: "黑料社频道分区清单",
      numberOfItems: channels.length,
      itemListElement: channelGroups.map((group, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: group.title,
        description: group.summary,
      })),
    },
    {
      "@type": "FAQPage",
      mainEntity: faqs.map((faq) => ({
        "@type": "Question",
        name: faq.q,
        acceptedAnswer: { "@type": "Answer", text: faq.a },
      })),
    },
  ];

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify({ "@context": "https://schema.org", "@graph": graph }),
      }}
    />
  );
}